var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"icon":"mdi-format-list-bulleted","label":_vm.$t('integrations.menu.command_runs'),"text":"","hide-label":_vm.icon,"to":{ name: 'commands_show', params: { id: _vm.item.id } }}})}
var staticRenderFns = []

export { render, staticRenderFns }